import './style.scss';
import Feature from 'ol/Feature.js';
import Geolocation from 'ol/Geolocation.js';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Point from 'ol/geom/Point.js';
import VectorLayer from 'ol/layer/Vector.js';
import { useGeographic } from 'ol/proj.js';
import VectorSource from 'ol/source/Vector.js';
import Icon from 'ol/style/Icon.js';
import Style from 'ol/style/Style.js';
import Overlay from 'ol/Overlay.js';
import CircleStyle from 'ol/style/Circle.js';
import Fill from 'ol/style/Fill.js';
import Stroke from 'ol/style/Stroke.js';
import { toLonLat } from 'ol/proj.js';
import Cluster from 'ol/source/Cluster.js';
import Text from 'ol/style/Text.js';
import { boundingExtent } from 'ol/extent.js';
import $ from 'jquery';
window.jQuery = window.$ = $;

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

const selectedKindKeys = new Set();
const selectedAttributeKeys = new Set();
let experienceFilterMin = 0;

const API_BASE = '/api/v1';

function pictureUrl(apiId, name) {
  return API_BASE + '/features/' + encodeURIComponent(apiId) + '/pictures/' + encodeURIComponent(name);
}

function isTokenValid(token) {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload.exp === 'number' && payload.exp > Date.now() / 1000;
  } catch { return false; }
}

const _stored = localStorage.getItem('admin_token');
if (_stored && !isTokenValid(_stored)) localStorage.removeItem('admin_token');

const admin = {
  token: isTokenValid(_stored) ? _stored : null,
  pickingCoords: false,
  editingId: null,
};
function isAdmin() { return !!admin.token; }

console.log("Executing module");

const blockingOverlay = $("#blocking-overlay");

function enableUI() {
  console.log('enableUI');
  blockingOverlay.hide();
}
function disableUI() {
  console.log('disableUI');
  blockingOverlay.show();
}

disableUI();

useGeographic();

const mapCenter = [5.590646, 59.595382];

// ─── Icon set — colour-adaptable SVG markers ──────────────────────
// Pin markers are 32×42 SVGs with a teardrop body and an inset white-circle
// "face" that holds an 18×18 glyph. Both pin body and glyph share the same
// fill, so colour is a single parameter. Attribute icons are 24×24 monochrome
// SVGs filled with the theme colour.

const ratingColors = {
  0: '#3182ce', // default — blue (no rating yet)
  1: '#e53e3e', // 1★ — red
  2: '#38a169', // 2★ — green
  3: '#d53f8c', // 3★ — pink
  4: '#ecc94b', // 4★ — yellow
};
const attributeIconColor = '#1e3a5f';

// Glyphs sit inside the pin's white "face" at translate(7,5) in a 18×18 area.
const kindGlyphs = {
  grocery:       '<path d="M2 4 H4.2 L5.6 13 H15 L16 6 H6.2"/><circle cx="7" cy="15.5" r="1.3"/><circle cx="13.5" cy="15.5" r="1.3"/>',
  nightStop:     '<path d="M1 7 H13 L15 9 V13 H1 Z"/><rect x="2.2" y="8" width="2.6" height="2.8" fill="white"/><rect x="6" y="8" width="2.6" height="2.8" fill="white"/><circle cx="4" cy="14.5" r="1.4"/><circle cx="12" cy="14.5" r="1.4"/>',
  utilities:     '<rect x="2" y="3" width="6" height="12" rx="0.5"/><rect x="3.5" y="4.5" width="3" height="3" fill="white"/><path d="M8 6 H10 V13 Q10 14.5 11.5 14.5 Q13 14.5 13 13 V8 L11.5 6 V8 Z"/>',
  museum:        '<polygon points="9,2 1,5 17,5"/><rect x="2" y="6" width="1.6" height="7"/><rect x="6" y="6" width="1.6" height="7"/><rect x="10.5" y="6" width="1.6" height="7"/><rect x="14.5" y="6" width="1.6" height="7"/><rect x="0.5" y="13.5" width="17" height="2"/>',
  playground:    '<circle cx="4.5" cy="3" r="1.8"/><path d="M4.5 5 V9 L11 14 L15 14 L15 12 L12 12 L7 8" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>',
  beach:         '<circle cx="9" cy="4" r="2.4"/><path d="M3 8 L9 4 L15 8 Z"/><path d="M1 13 Q3 11 5 13 Q7 15 9 13 Q11 11 13 13 Q15 15 17 13" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round"/>',
  hikingTrail:   '<polygon points="1,15 5,5 9,11 13,3 17,15"/>',
  animalPark:    '<circle cx="9" cy="11" r="3"/><circle cx="3.5" cy="7.5" r="1.6"/><circle cx="9" cy="3.5" r="1.6"/><circle cx="14.5" cy="7.5" r="1.6"/><circle cx="5" cy="14.5" r="1.3"/><circle cx="13" cy="14.5" r="1.3"/>',
  campingGround: '<polygon points="9,1.5 1,15 17,15"/><polygon points="9,5 5.5,15 12.5,15" fill="white"/>',
  food:          '<path d="M3 1.5 V15 M4.6 1.5 V6 Q4.6 7 3.8 7 H3.8 M6 1.5 V6 Q6 7 5.2 7 H5.2" stroke="currentColor" stroke-width="1.3" fill="none" stroke-linecap="round"/><path d="M12.5 1.5 Q14.5 1.5 14.5 5 V9 H12.5 Z M13.5 9 V15" stroke="currentColor" stroke-width="1.3" fill="currentColor" stroke-linejoin="round"/>',
  restArea:      '<rect x="0.5" y="7" width="17" height="1.8"/><rect x="2" y="8.8" width="1.6" height="6"/><rect x="14.4" y="8.8" width="1.6" height="6"/><rect x="0.5" y="11" width="17" height="1.4"/>',
};

// 24×24 glyphs — filled with theme colour.
const attrGlyphs = {
  electricity:    '<polygon points="14,1 4,13 11,13 8,23 18,11 12,11"/>',
  water:          '<path d="M12 1.5 C9 6 5 11 5 15.5 A7 7 0 0 0 19 15.5 C19 11 15 6 12 1.5 Z"/>',
  wasteWater:     '<path d="M12 1.5 C9 6 5 11 5 15.5 A7 7 0 0 0 19 15.5 C19 11 15 6 12 1.5 Z"/><path d="M8 11 L16 19 M16 11 L8 19" stroke="white" stroke-width="2" stroke-linecap="round"/>',
  parkingArea:    '<rect x="2" y="2" width="20" height="20" rx="3"/><path d="M9 6 V18 M9 6 H14 a3 3 0 0 1 0 6 H9" fill="none" stroke="white" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round"/>',
  paymentNeeded:  '<circle cx="12" cy="12" r="10"/><path d="M8 9.5 H16 M8 14 H16 M15.5 6.5 Q11 6.5 11 12 Q11 17.5 15.5 17.5" fill="none" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>',
  toilet:         '<line x1="12" y1="3" x2="12" y2="21" stroke="currentColor" stroke-width="1"/><circle cx="7" cy="5" r="2.2"/><path d="M5 9 H9 L10 17 H4 Z"/><circle cx="17" cy="5" r="2.2"/><path d="M14.5 9 H19.5 L18.2 14 H15.8 V17 H14.2 V14 L15.8 14 Z"/>',
  fireplace:      '<path d="M12 2 Q8 6 7 11 A5 5 0 0 0 17 11 C17 9 15 8 13.5 7 Q13.5 10 12 10 C12 7 13 4.5 12 2 Z"/>',
  washerDryer:    '<rect x="3" y="2" width="18" height="20" rx="1.5"/><circle cx="12" cy="14" r="6" fill="white"/><circle cx="12" cy="14" r="3.5"/><circle cx="6.5" cy="5.5" r="1.2" fill="white"/><circle cx="9.5" cy="5.5" r="1.2" fill="white"/>',
  playground:     '<circle cx="6" cy="4" r="2"/><path d="M6 6 V11 L13 15 H20 V13 H14 L8 9.5" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>',
  shower:         '<rect x="9" y="2.5" width="6" height="2.5" rx="0.8"/><rect x="11.4" y="5" width="1.2" height="3"/><ellipse cx="12" cy="9.5" rx="5" ry="2"/><line x1="8" y1="12" x2="6.5" y2="20" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><line x1="10" y1="12" x2="9" y2="21" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><line x1="12" y1="12" x2="12" y2="21" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><line x1="14" y1="12" x2="15" y2="21" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><line x1="16" y1="12" x2="17.5" y2="20" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>',
  noPayment:      '<circle cx="12" cy="12" r="10"/><path d="M8 9.5 H16 M8 14 H16 M15.5 6.5 Q11 6.5 11 12 Q11 17.5 15.5 17.5" fill="none" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/><line x1="4" y1="20" x2="20" y2="4" stroke="white" stroke-width="3" stroke-linecap="round"/>',
};

function svgDataUri(svg) {
  return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
}

function pinSvg(glyphName, color) {
  const glyph = kindGlyphs[glyphName] || '';
  return '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42">' +
    '<path d="M16 1 C7.7 1 1 7.7 1 16 C1 26 16 41 16 41 C16 41 31 26 31 16 C31 7.7 24.3 1 16 1 Z" fill="' + color + '" stroke="white" stroke-width="1.5"/>' +
    '<circle cx="16" cy="16" r="10" fill="white"/>' +
    '<g transform="translate(7,7)" fill="' + color + '">' + glyph + '</g>' +
  '</svg>';
}

function attrSvg(glyphName, color) {
  const glyph = attrGlyphs[glyphName] || '';
  return '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="' + color + '">' + glyph + '</svg>';
}

function createPinIcon(glyphName, color) {
  return new Icon({
    src: svgDataUri(pinSvg(glyphName, color)),
    anchor: [0.5, 0],
    anchorOrigin: 'bottom-left',
  });
}

function createAttrIcon(glyphName) {
  return new Icon({ src: svgDataUri(attrSvg(glyphName, attributeIconColor)) });
}

// Build attribute icons first so the attribute enum can reference them.
const attrIcons = {};
for (const name of Object.keys(attrGlyphs)) {
  attrIcons[name] = createAttrIcon(name);
}

// enum definitions
// every feature has exactly ONE kind value
const kind = Object.freeze({
  grocery:       { key: 0,  glyph: 'grocery',       title: 'Einkaufsmöglichkeit' },
  nightStop:     { key: 1,  glyph: 'nightStop',     title: 'Nachtrast' },
  utilities:     { key: 2,  glyph: 'utilities',     title: 'Ver-/Entsorgung' },
  museum:        { key: 3,  glyph: 'museum',        title: 'Museum' },
  playground:    { key: 4,  glyph: 'playground',    title: 'Spielplatz' },
  beach:         { key: 5,  glyph: 'beach',         title: 'Strand' },
  hikingTrail:   { key: 6,  glyph: 'hikingTrail',   title: 'Wanderstrecke' },
  animalPark:    { key: 7,  glyph: 'animalPark',    title: 'Tierpark' },
  campingGround: { key: 8,  glyph: 'campingGround', title: 'Campingplatz' },
  food:          { key: 9,  glyph: 'food',          title: 'Essen' },
  restArea:      { key: 10, glyph: 'restArea',      title: 'Rastplatz' },
});

// every feature can have multiple attributes, but doesn't have to
const attribute = Object.freeze({
  electricity:   { key: 2 ** 0, icon: attrIcons.electricity,   title: 'Landstrom' },
  water:         { key: 2 ** 1, icon: attrIcons.water,         title: 'Trinkwasser' },
  wasteWater:    { key: 2 ** 2, icon: attrIcons.wasteWater,    title: 'Abwasser' },
  parkingArea:   { key: 2 ** 3, icon: attrIcons.parkingArea,   title: 'Parkplatz' },
  paymentNeeded: { key: 2 ** 4, icon: attrIcons.paymentNeeded, title: 'Kostenpflichtig' },
  toilet:        { key: 2 ** 5, icon: attrIcons.toilet,        title: 'WC' },
  fireplace:     { key: 2 ** 6, icon: attrIcons.fireplace,     title: 'Feuerstelle' },
  washerDryer:   { key: 2 ** 7, icon: attrIcons.washerDryer,   title: 'Waschmaschine' },
  playground:    { key: 2 ** 8, icon: attrIcons.playground,    title: 'Spielplatz' },
  shower:        { key: 2 ** 9, icon: attrIcons.shower,        title: 'Dusche' },
});

const features = []

// One Icon per (kind, rating) — five variants per kind so we never allocate at render time.
const kindIcons = {};
for (const k of Object.values(kind)) {
  const variants = {};
  for (const rating of [0, 1, 2, 3, 4]) {
    variants[rating] = createPinIcon(k.glyph, ratingColors[rating]);
  }
  kindIcons[k.key] = variants;
}

// One Style per (kind, rating), cached.
const kindStyles = {};
for (const kKey of Object.keys(kindIcons)) {
  const byRating = {};
  for (const rating of [0, 1, 2, 3, 4]) {
    byRating[rating] = new Style({ image: kindIcons[kKey][rating] });
  }
  kindStyles[kKey] = byRating;
}

// One CircleStyle per max-rating tier for cluster bubbles (text varies per cluster size).
const clusterBubbleImage = {};
for (const rating of [0, 1, 2, 3, 4]) {
  clusterBubbleImage[rating] = new CircleStyle({
    radius: 14,
    fill: new Fill({ color: ratingColors[rating] }),
    stroke: new Stroke({ color: '#fff', width: 2 }),
  });
}

function getStyleForFeature(feature) {
  const k = feature.get('kind');
  const exp = feature.get('_experience') | 0;
  return kindStyles[k.key][exp >= 1 && exp <= 4 ? exp : 0];
}

function clusterStyleFunction(clusterFeature) {
  const clustered = clusterFeature.get('features');
  if (clustered.length === 1) {
    return getStyleForFeature(clustered[0]);
  }
  let maxExp = 0;
  for (const f of clustered) {
    const e = f.get('_experience') | 0;
    if (e > maxExp) maxExp = e;
  }
  return new Style({
    image: clusterBubbleImage[maxExp],
    text: new Text({
      text: clustered.length.toString(),
      fill: new Fill({ color: '#fff' }),
      font: 'bold 12px sans-serif',
    }),
  });
}

const filteredSource = new VectorSource();
const clusterSource = new Cluster({ distance: 40, source: filteredSource });

const view = new View({
  center: mapCenter,
  zoom: 7,
})

const popupContainer = document.getElementById('popup');
const popupCloser = document.getElementById('popup-closer');
const popupAttributes = document.getElementById('popup-attributes');
const popupTitle = document.getElementById('popup-title');
const popupDescription = document.getElementById('popup-description');
const popupLinks = document.getElementById('popup-links');
const popupPictures = document.getElementById('popup-pictures');

const overlay = new Overlay({
  element: popupContainer,
  autoPan: {
    animation: {
      duration: 250,
    },
  },
});

// close popup on click on x
popupCloser.onclick = function () {
  overlay.setPosition(undefined);
  popupCloser.blur();
  return false;
};

console.log("loading map");
const map = new Map({
  target: document.getElementById('map'),
  view: view,
  layers: [
    new TileLayer({
      source: new OSM(),
    }),
    new VectorLayer({
      source: clusterSource,
      style: clusterStyleFunction,
    }),
  ],
  overlays: [overlay],
});

// display popup on click
map.on('singleclick', function (evt) {
  if (admin.pickingCoords) {
    const lonLat = evt.coordinate;
    document.getElementById('ff-lon').value = lonLat[0].toFixed(8);
    document.getElementById('ff-lat').value = lonLat[1].toFixed(8);
    window.cancelCoordPick();
    return;
  }
  const clusterFeature = map.forEachFeatureAtPixel(evt.pixel, f => f);
  if (!clusterFeature) return;
  const clustered = clusterFeature.get('features');
  if (!clustered) return;
  if (clustered.length === 1) {
    showFeature(clustered[0].getId());
  } else {
    const coords = clustered.map(f => f.getGeometry().getCoordinates());
    map.getView().fit(boundingExtent(coords), { padding: [50, 50, 50, 50], duration: 500, maxZoom: 15 });
  }
});

// helper to show feature popup
function showFeature(featureId) {
  var feature = features[featureId]
  if (!feature) {
    return
  }
  const extent = feature.getGeometry().getExtent()
  const coordinate = feature.getGeometry().getCoordinates()

  let attributes = '';
  getDetailIconsForFeature(feature.getId()).forEach(function (res) {
    attributes += '<img src="' + res.icon.getSrc() + '" alt="' + res.title + '" title="' + res.title + '" height="25px" />';
  })
  popupAttributes.innerHTML = attributes;
  popupTitle.textContent = feature.get('name') || '';
  popupDescription.innerHTML = feature.get('description');
  popupLinks.innerHTML = '';
  (feature.get('links') || []).forEach(url => {
    const li = document.createElement("li");
    if (url.indexOf('https://www.vegvesen.no/trafikk/kart') != -1) { // special handling for vegvesen map links
      li.innerHTML = '<li><a href="' + url + '" target="_blank">Vegvesen kart</a></li>';
    } else {
      li.innerHTML = '<li><a href="' + url + '" target="_blank">' + url + '</a></li>';
    }
    popupLinks.appendChild(li)
  });

  // Add always a Google Maps link
  const li = document.createElement("li");
  li.innerHTML = '<li><a href="https://www.google.com/maps/place/' + coordinate[1] + ',' + coordinate[0] + '?z=5" target="_blank">Google Maps</a></li>';
  popupLinks.appendChild(li)

  const apiId = feature.get('_apiId');
  const pics = feature.get('_pictures') || [];
  popupPictures.innerHTML = '';
  if (apiId && pics.length > 0) {
    pics.forEach((name, idx) => {
      const img = document.createElement('img');
      img.className = 'popup-thumbnail';
      img.src = pictureUrl(apiId, name);
      img.alt = '';
      img.addEventListener('click', () => openLightbox(apiId, pics, idx));
      popupPictures.appendChild(img);
    });
  }

  const popupAdmin = document.getElementById('popup-admin');
  if (popupAdmin) {
    if (isAdmin() && apiId) {
      renderPopupStars(apiId, feature.get('_experience') | 0);
      document.getElementById('popup-edit-btn').onclick = () => { overlay.setPosition(undefined); window.openFeatureForm(apiId); };
      document.getElementById('popup-delete-btn').onclick = () => { overlay.setPosition(undefined); window.deleteFeature(apiId); };
      popupAdmin.style.display = '';
    } else {
      popupAdmin.style.display = 'none';
    }
  }

  overlay.setPosition(coordinate);
  return extent
}

// change mouse cursor when over feature marker
map.on('pointermove', function (e) {
  const hit = map.hasFeatureAtPixel(e.pixel);
  map.getTarget().style.cursor = hit ? 'pointer' : '';
});

// show popup from menu click
window.showMenuPopup = function (featureId) {
  const extent = showFeature(featureId);
  map.getView().fit(extent, { maxZoom: 15, duration: 1000 });
}

// helper to extract kind icon from feature — picks the rating-coloured variant
function getIconForFeature(featureId) {
  const feature = features[featureId];
  if (!feature) return kindIcons[kind.restArea.key][0];
  const k = feature.get('kind');
  const exp = feature.get('_experience') | 0;
  return kindIcons[k.key][exp >= 1 && exp <= 4 ? exp : 0];
}

// helper to extract attribute icons from feature
function getDetailIconsForFeature(featureId) {
  var feature = features[featureId]
  if (!feature) {
    return []
  }

  let icons = []
  for (const [_key, attr] of Object.entries(attribute)) {
    if (attr.icon != null && attr.icon != undefined) {
      if (feature.get('attributes') & attr.key) {
        icons.push({ icon: attr.icon, title: attr.title });
      }
    }
  }

  return icons
}

// get geo location and zoom in
console.log("tracking geo location");
const geolocation = new Geolocation({
  tracking: true,
  // enableHighAccuracy must be set to true to have the heading value.
  trackingOptions: {
    enableHighAccuracy: true,
  },
  projection: view.getProjection(),
});

const accuracyFeature = new Feature();
geolocation.on('change:accuracyGeometry', function () {
  accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
});

const positionFeature = new Feature();
positionFeature.setStyle(
  new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({
        color: '#3399CC',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 2,
      }),
    }),
  }),
);

let geolocationUpdated = false;
geolocation.on('change:position', function () {
  const coordinate = geolocation.getPosition()
  if (coordinate) {
    const point = new Point(toLonLat(coordinate));
    positionFeature.setGeometry(point);
    if (!geolocationUpdated) {
      view.fit(point.getExtent(), { maxZoom: 10, duration: 1000 });
      geolocationUpdated = true;
    }
  }
});

new VectorLayer({
  map: map,
  source: new VectorSource({
    features: [accuracyFeature, positionFeature],
  }),
});

function setupMenuList() {
  const ul = document.querySelector('#map-list ul');
  ul.innerHTML = '';

  features.forEach(feature => {
    const featureId = feature.getId();
    const name = feature.get('name') || '';
    const kindIcon = getIconForFeature(featureId);
    const apiId = feature.get('_apiId') || '';

    const li = document.createElement('li');
    li.id = 'menuFeature' + featureId;

    const kindImg = document.createElement('img');
    kindImg.className = 'menu-kind-icon';
    kindImg.src = kindIcon.getSrc();
    kindImg.height = 25;
    li.appendChild(kindImg);

    const a = document.createElement('a');
    a.href = 'javascript:void(0)';
    a.textContent = name;
    a.addEventListener('click', () => window.showMenuPopup(featureId));
    li.appendChild(a);

    getDetailIconsForFeature(featureId).forEach(res => {
      const img = document.createElement('img');
      img.src = res.icon.getSrc();
      img.alt = res.title;
      img.title = res.title;
      img.height = 25;
      li.appendChild(img);
    });

    if (isAdmin()) {
      const editBtn = document.createElement('button');
      editBtn.className = 'admin-edit-btn';
      editBtn.textContent = '✎';
      editBtn.addEventListener('click', () => window.openFeatureForm(apiId));
      li.appendChild(editBtn);

      const delBtn = document.createElement('button');
      delBtn.className = 'admin-delete-btn';
      delBtn.textContent = '✕';
      delBtn.addEventListener('click', () => window.deleteFeature(apiId));
      li.appendChild(delBtn);
    }

    ul.appendChild(li);
  });
}

let menuElements = {};

window.updateMenuList = function () {
  console.log("Update menu list");
  disableUI();
  const selectedKinds = [...selectedKindKeys];
  const selectedAttributes = [...selectedAttributeKeys];
  let searchText = document.getElementById('map-filter-search').value;
  if (typeof (searchText) == "string") {
    searchText = searchText.trim().toLocaleLowerCase();
  } else {
    searchText = "";
  }
  console.log('before feature loop');
  const visibleFeatures = [];
  features.forEach(feature => {
    const featureId = feature.getId();
    const el = menuElements[featureId];
    // check for selected kinds
    const kind = feature.get('kind');
    if (selectedKinds.length > 0 && !selectedKinds.includes(kind.key)) {
      el.style.display = 'none';
      return;
    }

    // check for selected attributes
    const attributes = feature.get('attributes');
    let allAttributesMatched = true;
    selectedAttributes.forEach(attribute => {
      if (attribute < 0) { // Negated attribute
        if (attributes & -attribute) {
          allAttributesMatched = false;
          return;
        }
      } else { // Regular attribute
        if ((attributes & attribute) <= 0) {
          allAttributesMatched = false;
          return;
        }
      }
    });
    if (!allAttributesMatched) {
      el.style.display = 'none';
      return;
    }

    // experience-min filter (star threshold)
    if (experienceFilterMin > 0 && (feature.get('_experience') | 0) < experienceFilterMin) {
      el.style.display = 'none';
      return;
    }

    // check for search text
    if (searchText != "") {
      let cachedResults = feature.get('searchMatches');
      const matches = cachedResults[searchText];
      if (matches != undefined) { // use cached result
        if (!matches) {
          el.style.display = 'none';
          return;
        }
      } else {
        const body = feature.get('searchBody');
        if (body.indexOf(searchText) == -1) {
          cachedResults[searchText] = false;
          feature.set('searchMatches', cachedResults);
          el.style.display = 'none';
          return;
        }
        cachedResults[searchText] = true;
        feature.set('searchMatches', cachedResults);
      }
    }

    // make visible on map and in list
    el.style.display = '';
    visibleFeatures.push(feature);
  });
  console.log('after feature loop');

  filteredSource.clear();
  filteredSource.addFeatures(visibleFeatures);
  enableUI();
}

window.resetFilters = function () {
  selectedKindKeys.clear();
  selectedAttributeKeys.clear();
  experienceFilterMin = 0;
  document.querySelectorAll('.filter-btn.active').forEach(b => b.classList.remove('active'));
  document.getElementById('map-filter-search').value = '';
  window.updateMenuList();
};

// Status filter — star thresholds (≥1, ≥2, ≥3, =4). Each star in the label
// is coloured by its own position, matching the marker palette.
(function () {
  const div = document.getElementById('map-filter-status');
  if (!div) return;
  const buttons = [];
  for (let min = 1; min <= 4; min++) {
    const btn = document.createElement('button');
    btn.className = 'filter-btn filter-btn-exp';
    let stars = '';
    for (let i = 1; i <= min; i++) {
      stars += '<span class="rating-star" style="color:' + ratingColors[i] + '">★</span>';
    }
    btn.innerHTML = stars + ' ' + (min === 4 ? '4' : '≥' + min);
    btn.addEventListener('click', () => {
      const newMin = experienceFilterMin === min ? 0 : min;
      experienceFilterMin = newMin;
      buttons.forEach(b => b.classList.toggle('active', parseInt(b.dataset.min, 10) === newMin));
      window.updateMenuList();
    });
    btn.dataset.min = String(min);
    div.appendChild(btn);
    buttons.push(btn);
  }
})();

// create kind filter buttons (default-blue variant for the swatch)
const kindFilterDiv = document.getElementById('map-filter-kind');
for (const details of Object.values(kind).sort((a, b) => a.title.localeCompare(b.title))) {
  const btn = document.createElement('button');
  btn.className = 'filter-btn';
  const iconObj = kindIcons[details.key][0];
  btn.innerHTML = '<img src="' + iconObj.getSrc() + '" height="16px" /> ' + details.title;
  btn.addEventListener('click', () => {
    if (selectedKindKeys.has(details.key)) {
      selectedKindKeys.delete(details.key);
      btn.classList.remove('active');
    } else {
      selectedKindKeys.add(details.key);
      btn.classList.add('active');
    }
    window.updateMenuList();
  });
  kindFilterDiv.appendChild(btn);
}

// create attribute filter buttons
const attrFilterDiv = document.getElementById('map-filter-attribute');
for (const details of Object.values(attribute).sort((a, b) => a.title.localeCompare(b.title))) {
  const btn = document.createElement('button');
  btn.className = 'filter-btn';
  if (details.icon) {
    btn.innerHTML = '<img src="' + details.icon.getSrc() + '" height="16px" /> ' + details.title;
  } else {
    btn.textContent = details.title;
  }
  btn.addEventListener('click', () => {
    if (selectedAttributeKeys.has(details.key)) {
      selectedAttributeKeys.delete(details.key);
      btn.classList.remove('active');
    } else {
      selectedAttributeKeys.add(details.key);
      btn.classList.add('active');
    }
    window.updateMenuList();
  });
  attrFilterDiv.appendChild(btn);

  if (details.key === attribute.paymentNeeded.key) {
    const negBtn = document.createElement('button');
    negBtn.className = 'filter-btn';
    const negKey = -details.key;
    negBtn.innerHTML = '<img src="' + attrIcons.noPayment.getSrc() + '" height="16px" /> NICHT ' + details.title;
    negBtn.addEventListener('click', () => {
      if (selectedAttributeKeys.has(negKey)) {
        selectedAttributeKeys.delete(negKey);
        negBtn.classList.remove('active');
      } else {
        selectedAttributeKeys.add(negKey);
        negBtn.classList.add('active');
      }
      window.updateMenuList();
    });
    attrFilterDiv.appendChild(negBtn);
  }
}

// ─── API helpers ──────────────────────────────────────────────────

async function apiRequest(method, path, body) {
  const opts = {
    method,
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + admin.token },
  };
  if (body !== undefined) opts.body = JSON.stringify(body);
  const res = await fetch(API_BASE + path, opts);
  if (res.status === 401) {
    admin.token = null;
    localStorage.removeItem('admin_token');
    renderAdminControls();
    window.openLoginModal();
    throw new Error('Unauthorized');
  }
  return res;
}

function apiFeatureToOLFeature(apiFeature) {
  const kindEntry = Object.values(kind).find(k => k.key === apiFeature.kind) || kind.restArea;
  const f = new Feature({
    geometry: new Point([apiFeature.lon, apiFeature.lat]),
    name: apiFeature.name,
    description: apiFeature.description || '',
    links: apiFeature.links || [],
    kind: kindEntry,
    attributes: apiFeature.attributes || 0,
    _apiId: apiFeature.id,
    _source: apiFeature.source,
    _experience: apiFeature.experience | 0,
    _pictures: apiFeature.pictures || [],
  });
  return f;
}

async function loadAllFeatures(bustCache = false) {
  // The list is cached for 30s (see Cache-Control on the server). Right after a
  // mutation we append a unique query param so the refetch is a cache miss and
  // reflects the change immediately, instead of waiting up to 30s — otherwise a
  // newly added entry would only show after a full page reload.
  const url = API_BASE + '/features' + (bustCache ? '?t=' + Date.now() : '');
  const res = await fetch(url);
  if (!res.ok) throw new Error('HTTP ' + res.status);
  const data = await res.json();
  data.forEach(apiFeature => features.push(apiFeatureToOLFeature(apiFeature)));
}

async function reloadAllFeatures() {
  features.length = 0;
  filteredSource.clear();
  await loadAllFeatures(true);
  finishSetup();
}

function finishSetup() {
  features.sort((a, b) => ('' + a.get('name')).localeCompare('' + b.get('name')));
  for (let i = 0; i < features.length; i++) {
    features[i].setId(i);
    features[i].setStyle(getStyleForFeature(features[i]));
    features[i].set('searchBody', ((features[i].get('name') || '') + (features[i].get('description') || '')).toLowerCase());
    features[i].set('searchMatches', {});
  }
  filteredSource.addFeatures(features);
  setupMenuList();
  features.forEach(f => {
    menuElements[f.getId()] = document.getElementById('menuFeature' + f.getId());
  });
  document.getElementById('map-filter-search').addEventListener('input', debounce(() => {
    window.updateMenuList();
  }, 250));
  populateFeatureFormEnums();
  renderAdminControls();
  enableUI();
}

// ─── Admin UI ─────────────────────────────────────────────────────

function populateFeatureFormEnums() {
  const kindSel = document.getElementById('ff-kind');
  if (kindSel.options.length > 0) return;
  for (const [key, k] of Object.entries(kind)) {
    const opt = document.createElement('option');
    opt.value = k.key;
    opt.textContent = k.title;
    kindSel.appendChild(opt);
  }
  const attrsDiv = document.getElementById('ff-attributes');
  if (attrsDiv.children.length > 0) return;
  for (const [key, attr] of Object.entries(attribute)) {
    const label = document.createElement('label');
    label.className = 'admin-attr-check';
    const cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.value = attr.key;
    cb.id = 'ff-attr-' + attr.key;
    label.appendChild(cb);
    label.append(' ' + attr.title);
    attrsDiv.appendChild(label);
  }
}

function renderAdminControls() {
  document.getElementById('admin-add-btn')?.remove();
  document.getElementById('admin-login-btn')?.remove();
  const header = document.getElementById('sidebar-header');
  const btn = document.createElement('button');
  if (isAdmin()) {
    btn.id = 'admin-add-btn';
    btn.textContent = '+ Eintrag';
    btn.onclick = () => window.openFeatureForm(null);
  } else {
    btn.id = 'admin-login-btn';
    btn.textContent = 'Admin';
    btn.onclick = () => window.openLoginModal();
  }
  header.appendChild(btn);
}

window.openLoginModal = function () {
  document.getElementById('admin-login-error').style.display = 'none';
  document.getElementById('admin-username').value = '';
  document.getElementById('admin-password').value = '';
  document.getElementById('admin-login-modal').style.display = 'flex';
  setTimeout(() => document.getElementById('admin-username').focus(), 50);
};

window.closeLoginModal = function () {
  document.getElementById('admin-login-modal').style.display = 'none';
};

document.getElementById('admin-login-modal').addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    window.submitLogin();
  } else if (e.key === 'Escape') {
    e.preventDefault();
    window.closeLoginModal();
  }
});

window.submitLogin = async function () {
  const username = document.getElementById('admin-username').value.trim();
  const password = document.getElementById('admin-password').value;
  const errEl = document.getElementById('admin-login-error');
  errEl.style.display = 'none';
  try {
    const res = await fetch(API_BASE + '/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      errEl.textContent = data.error || 'Login fehlgeschlagen';
      errEl.style.display = 'block';
      return;
    }
    const data = await res.json();
    admin.token = data.token;
    localStorage.setItem('admin_token', data.token);
    window.closeLoginModal();
    await reloadAllFeatures();
  } catch (e) {
    errEl.textContent = 'Verbindungsfehler';
    errEl.style.display = 'block';
  }
};

window.openFeatureForm = function (apiId) {
  admin.editingId = apiId || null;
  const titleEl = document.getElementById('ff-title');
  const errEl = document.getElementById('ff-error');
  errEl.style.display = 'none';
  if (apiId) {
    titleEl.textContent = 'Eintrag bearbeiten';
    const f = features.find(f => f.get('_apiId') === apiId);
    if (f) {
      document.getElementById('ff-name').value = f.get('name') || '';
      document.getElementById('ff-description').value = f.get('description') || '';
      document.getElementById('ff-kind').value = f.get('kind').key;
      document.getElementById('ff-links').value = (f.get('links') || []).join('\n');
      const coords = f.getGeometry().getCoordinates();
      document.getElementById('ff-lon').value = coords[0];
      document.getElementById('ff-lat').value = coords[1];
      const attrs = f.get('attributes') || 0;
      document.querySelectorAll('#ff-attributes input[type=checkbox]').forEach(cb => {
        cb.checked = !!(attrs & parseInt(cb.value));
      });
      renderPicturesForm(f.get('_pictures') || []);
    }
  } else {
    titleEl.textContent = 'Neuer Eintrag';
    document.getElementById('ff-name').value = '';
    document.getElementById('ff-description').value = '';
    document.getElementById('ff-kind').value = 10;
    document.getElementById('ff-links').value = '';
    document.getElementById('ff-lon').value = '';
    document.getElementById('ff-lat').value = '';
    document.querySelectorAll('#ff-attributes input[type=checkbox]').forEach(cb => { cb.checked = false; });
    renderPicturesForm(null);
  }
  document.getElementById('admin-feature-modal').style.display = 'flex';
};

window.closeFeatureForm = function () {
  window.cancelCoordPick();
  document.getElementById('admin-feature-modal').style.display = 'none';
};

window.submitFeatureForm = async function () {
  const errEl = document.getElementById('ff-error');
  errEl.style.display = 'none';
  const name = document.getElementById('ff-name').value.trim();
  const lon = parseFloat(document.getElementById('ff-lon').value);
  const lat = parseFloat(document.getElementById('ff-lat').value);
  if (!name) { errEl.textContent = 'Name ist erforderlich'; errEl.style.display = 'block'; return; }
  if (!lon || !lat) { errEl.textContent = 'Koordinaten sind erforderlich'; errEl.style.display = 'block'; return; }
  let attrs = 0;
  document.querySelectorAll('#ff-attributes input[type=checkbox]:checked').forEach(cb => {
    attrs |= parseInt(cb.value);
  });
  const body = {
    name,
    description: document.getElementById('ff-description').value.trim(),
    kind: parseInt(document.getElementById('ff-kind').value),
    attributes: attrs,
    links: document.getElementById('ff-links').value.split('\n').map(s => s.trim()).filter(Boolean),
    lon,
    lat,
  };
  try {
    const method = admin.editingId ? 'PUT' : 'POST';
    const path = admin.editingId ? '/features/' + admin.editingId : '/features';
    const res = await apiRequest(method, path, body);
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      errEl.textContent = data.error || 'Fehler beim Speichern';
      errEl.style.display = 'block';
      return;
    }
    window.closeFeatureForm();
    await reloadAllFeatures();
  } catch (e) {
    if (e.message !== 'Unauthorized') {
      errEl.textContent = 'Verbindungsfehler';
      errEl.style.display = 'block';
    }
  }
};

window.deleteFeature = async function (apiId) {
  if (!confirm('Eintrag wirklich löschen?')) return;
  try {
    const res = await apiRequest('DELETE', '/features/' + apiId);
    if (!res.ok && res.status !== 404) {
      alert('Fehler beim Löschen');
      return;
    }
    await reloadAllFeatures();
  } catch (e) {
    if (e.message !== 'Unauthorized') alert('Verbindungsfehler');
  }
};

window.startCoordPick = function () {
  admin.pickingCoords = true;
  document.body.classList.add('picking-coords');
  document.querySelector('.admin-feature-form').classList.add('picking-mode');
  const btn = document.getElementById('ff-pick-coords');
  btn.classList.add('active');
  btn.title = 'Abbrechen';
  btn.onclick = window.cancelCoordPick;
};

window.cancelCoordPick = function () {
  admin.pickingCoords = false;
  document.body.classList.remove('picking-coords');
  const form = document.querySelector('.admin-feature-form');
  if (form) form.classList.remove('picking-mode');
  const btn = document.getElementById('ff-pick-coords');
  if (btn) {
    btn.classList.remove('active');
    btn.title = 'Auf Karte wählen';
    btn.onclick = window.startCoordPick;
  }
};

// ─── Sidebar toggle ───────────────────────────────────────────────

window.toggleSidebar = function () {
  const sidebar = document.getElementById('map-list');
  const btn = document.getElementById('sidebar-toggle');
  sidebar.classList.toggle('collapsed');
  const collapsed = sidebar.classList.contains('collapsed');
  btn.textContent = collapsed ? '▶' : '◀';
  btn.title = collapsed ? 'Seitenleiste öffnen' : 'Seitenleiste schließen';
  map.updateSize();
};

// ─── Geolocation button ───────────────────────────────────────────

window.centerOnLocation = function () {
  const geom = positionFeature.getGeometry();
  if (geom) {
    view.animate({ center: geom.getCoordinates(), zoom: Math.max(view.getZoom() || 0, 12), duration: 800 });
  }
};

// ─── Filter resize handle ─────────────────────────────────────────

(function () {
  const handle = document.getElementById('filter-resize');
  const filters = document.getElementById('map-filters');
  if (!handle || !filters) return;
  // Set initial max-height to content height so the handle has a starting point
  filters.style.maxHeight = filters.scrollHeight + 'px';
  let dragging = false, startY = 0, startH = 0;
  handle.addEventListener('mousedown', e => {
    dragging = true;
    startY = e.clientY;
    startH = filters.offsetHeight;
    e.preventDefault();
    const onMove = e2 => {
      if (!dragging) return;
      const h = Math.max(60, Math.min(startH + e2.clientY - startY, window.innerHeight * 0.8));
      filters.style.maxHeight = h + 'px';
    };
    const onUp = () => { dragging = false; document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  });
})();

// ─── Experience (star) rating (admin) ─────────────────────────────

window.setExperience = async function (apiId, stars) {
  try {
    const res = await apiRequest('PUT', '/features/' + apiId + '/experience', { experience: stars });
    if (!res.ok) { alert('Fehler beim Speichern'); return; }
    const updated = await res.json();
    applyFeatureUpdate(updated);
  } catch (e) {
    if (e.message !== 'Unauthorized') alert('Verbindungsfehler');
  }
};

function renderPopupStars(apiId, current) {
  const strip = document.getElementById('popup-experience');
  strip.innerHTML = '';
  for (let n = 0; n <= 4; n++) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'popup-star';
    if (n === 0) {
      b.textContent = '∅';
      b.title = 'Nicht besucht (0 Sterne)';
      if (current === 0) b.classList.add('active');
    } else {
      b.innerHTML = '<span class="rating-star" style="color:' + ratingColors[n] + '">★</span>';
      b.title = n + ' ' + (n === 1 ? 'Stern' : 'Sterne');
      if (n <= current) b.classList.add('filled');
    }
    b.addEventListener('click', () => window.setExperience(apiId, n));
    strip.appendChild(b);
  }
}

function applyFeatureUpdate(updated) {
  const f = features.find(f => f.get('_apiId') === updated.id);
  if (!f) return;
  const exp = updated.experience | 0;
  f.set('_experience', exp);
  f.set('_pictures', updated.pictures || []);
  f.setStyle(getStyleForFeature(f));
  f.changed();
  clusterSource.refresh();
  const li = menuElements[f.getId()];
  if (li) {
    const kindImg = li.querySelector('.menu-kind-icon');
    if (kindImg) kindImg.src = getIconForFeature(f.getId()).getSrc();
  }
  if (overlay.getPosition()) showFeature(f.getId());
}

// ─── Picture management (admin) ───────────────────────────────────

function renderPicturesForm(pictures) {
  const list = document.getElementById('ff-pictures-list');
  const empty = document.getElementById('ff-pictures-empty');
  const add = document.getElementById('ff-pictures-add');
  list.innerHTML = '';
  if (admin.editingId == null) {
    empty.style.display = '';
    add.style.display = 'none';
    return;
  }
  empty.style.display = 'none';
  add.style.display = '';
  (pictures || []).forEach((name, idx) => {
    const item = document.createElement('div');
    item.className = 'ff-picture-item';
    const img = document.createElement('img');
    img.src = pictureUrl(admin.editingId, name);
    img.alt = '';
    item.appendChild(img);
    const controls = document.createElement('div');
    controls.className = 'ff-picture-controls';
    const up = ffPicBtn('▲', () => reorderPicture(idx, idx - 1));
    up.disabled = idx === 0;
    const down = ffPicBtn('▼', () => reorderPicture(idx, idx + 1));
    down.disabled = idx === pictures.length - 1;
    const remove = ffPicBtn('✕', () => removePicture(name), 'ff-picture-remove');
    controls.appendChild(up);
    controls.appendChild(down);
    controls.appendChild(remove);
    item.appendChild(controls);
    list.appendChild(item);
  });
}

function ffPicBtn(label, onClick, extraClass) {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'ff-picture-btn' + (extraClass ? ' ' + extraClass : '');
  b.textContent = label;
  b.addEventListener('click', onClick);
  return b;
}

async function uploadPictures(fileList) {
  if (!admin.editingId || !fileList || fileList.length === 0) return;
  const errEl = document.getElementById('ff-error');
  errEl.style.display = 'none';
  const fd = new FormData();
  for (const f of fileList) fd.append('files', f);
  try {
    const res = await fetch(API_BASE + '/features/' + admin.editingId + '/pictures', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + admin.token },
      body: fd,
    });
    if (res.status === 401) {
      admin.token = null;
      localStorage.removeItem('admin_token');
      renderAdminControls();
      window.openLoginModal();
      return;
    }
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      errEl.textContent = data.error || 'Upload fehlgeschlagen';
      errEl.style.display = 'block';
      return;
    }
    const updated = await res.json();
    applyFeatureUpdate(updated);
    renderPicturesForm(updated.pictures || []);
  } catch (e) {
    errEl.textContent = 'Verbindungsfehler';
    errEl.style.display = 'block';
  }
}

async function removePicture(name) {
  if (!admin.editingId) return;
  if (!confirm('Bild wirklich löschen?')) return;
  try {
    const res = await apiRequest('DELETE', '/features/' + admin.editingId + '/pictures/' + encodeURIComponent(name));
    if (!res.ok) { alert('Fehler beim Löschen'); return; }
    const updated = await res.json();
    applyFeatureUpdate(updated);
    renderPicturesForm(updated.pictures || []);
  } catch (e) {
    if (e.message !== 'Unauthorized') alert('Verbindungsfehler');
  }
}

async function reorderPicture(fromIdx, toIdx) {
  if (!admin.editingId) return;
  const f = features.find(f => f.get('_apiId') === admin.editingId);
  if (!f) return;
  const order = [...(f.get('_pictures') || [])];
  if (toIdx < 0 || toIdx >= order.length) return;
  const [moved] = order.splice(fromIdx, 1);
  order.splice(toIdx, 0, moved);
  try {
    const res = await apiRequest('PUT', '/features/' + admin.editingId + '/pictures', order);
    if (!res.ok) { alert('Fehler beim Sortieren'); return; }
    const updated = await res.json();
    applyFeatureUpdate(updated);
    renderPicturesForm(updated.pictures || []);
  } catch (e) {
    if (e.message !== 'Unauthorized') alert('Verbindungsfehler');
  }
}

document.getElementById('ff-pictures-input').addEventListener('change', (e) => {
  uploadPictures(e.target.files);
  e.target.value = '';
});

// ─── Lightbox ─────────────────────────────────────────────────────

const lightboxEl = document.getElementById('lightbox');
const lightboxImg = document.getElementById('lightbox-img');
const lightboxCounter = document.getElementById('lightbox-counter');
let lightboxState = { apiId: null, pictures: [], index: 0 };

function openLightbox(apiId, pictures, index) {
  lightboxState = { apiId, pictures: [...pictures], index };
  lightboxEl.style.display = 'flex';
  updateLightboxImage();
}
function closeLightbox() { lightboxEl.style.display = 'none'; lightboxImg.src = ''; }
function lightboxNext() {
  const n = lightboxState.pictures.length;
  if (n === 0) return;
  lightboxState.index = (lightboxState.index + 1) % n;
  updateLightboxImage();
}
function lightboxPrev() {
  const n = lightboxState.pictures.length;
  if (n === 0) return;
  lightboxState.index = (lightboxState.index - 1 + n) % n;
  updateLightboxImage();
}
function updateLightboxImage() {
  const { pictures, apiId, index } = lightboxState;
  if (!pictures[index]) return;
  lightboxImg.src = pictureUrl(apiId, pictures[index]);
  lightboxCounter.textContent = (index + 1) + ' / ' + pictures.length;
  document.getElementById('lightbox-prev').style.visibility = pictures.length > 1 ? '' : 'hidden';
  document.getElementById('lightbox-next').style.visibility = pictures.length > 1 ? '' : 'hidden';
}
document.getElementById('lightbox-close').addEventListener('click', closeLightbox);
document.getElementById('lightbox-prev').addEventListener('click', lightboxPrev);
document.getElementById('lightbox-next').addEventListener('click', lightboxNext);
lightboxEl.addEventListener('click', (e) => { if (e.target === lightboxEl) closeLightbox(); });
document.addEventListener('keydown', (e) => {
  if (lightboxEl.style.display === 'none' || lightboxEl.style.display === '') return;
  if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); }
  else if (e.key === 'ArrowRight') { e.preventDefault(); lightboxNext(); }
  else if (e.key === 'ArrowLeft') { e.preventDefault(); lightboxPrev(); }
});

// ─── Start ────────────────────────────────────────────────────────

loadAllFeatures().then(finishSetup).catch(err => {
  console.error('Failed to load features:', err);
  const ul = document.querySelector('#map-list ul');
  if (ul) {
    const li = document.createElement('li');
    li.style.cssText = 'padding:12px;color:#c53030;font-size:0.82em;';
    li.textContent = 'Fehler beim Laden der Einträge. Ist der Server gestartet?';
    ul.appendChild(li);
  }
  enableUI();
});
